var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3089 1.47557C19.3097 1.60969 19.2573 1.73866 19.1631 1.83416L11.0751 10.2217C10.9166 10.3863 10.7266 10.5172 10.5163 10.6067C10.3061 10.6961 10.08 10.7422 9.85151 10.7422C9.62304 10.7422 9.39692 10.6961 9.18668 10.6067C8.97644 10.5172 8.78641 10.3863 8.62796 10.2217L0.549752 1.83416C0.492445 1.78844 0.445533 1.73104 0.412138 1.66578C0.378743 1.60052 0.359632 1.52889 0.356076 1.45566C0.352521 1.38244 0.364602 1.3093 0.391516 1.24111C0.418431 1.17292 0.459561 1.11124 0.512168 1.06018C0.564776 1.00913 0.627656 0.969863 0.696622 0.945001C0.765587 0.920139 0.839058 0.910253 0.912142 0.915998C0.985227 0.921743 1.05625 0.942988 1.12048 0.978321C1.18472 1.01365 1.24069 1.06226 1.28467 1.12091L9.37273 9.50254C9.43483 9.56678 9.50922 9.61786 9.59148 9.65274C9.67373 9.68763 9.76216 9.70561 9.85151 9.70561C9.94086 9.70561 10.0293 9.68763 10.1115 9.65274C10.1938 9.61786 10.2682 9.56678 10.3303 9.50254L18.4183 1.12091C18.4898 1.04708 18.5816 0.996144 18.682 0.97458C18.7824 0.953017 18.887 0.961798 18.9825 0.999807C19.0779 1.03782 19.1599 1.10334 19.218 1.18805C19.2762 1.27276 19.3078 1.37284 19.3089 1.47557Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.1c75020027960c7c954ed10de34aed46.svg";
export { ForwardRef as ReactComponent };